"use client";

import { useApiGet } from "@/hooks/use-api";
import { integrationKeys } from "./keys";
import type { JiraConnectionStatus } from "./types";

/**
 * useJiraStatus
 *
 * Jira connection status for the current workspace. Gated on workspaceId so
 * the request never fires with an empty one (the backend 400s that).
 */
export function useJiraStatus(workspaceId: string | undefined) {
  const safeId = workspaceId ?? "";

  const { data, isLoading, isError, refetch } = useApiGet<JiraConnectionStatus>(
    integrationKeys.jira(safeId),
    `/api/jira/status?workspaceId=${encodeURIComponent(safeId)}`,
    undefined,
    {
      enabled: !!safeId,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );

  return {
    connected: data?.connected ?? false,
    userEmail: data?.userEmail,
    sites: data?.sites ?? [],
    isLoading,
    isError,
    refetch,
  };
}
